import { render } from "./LoadingSpinner.vue?vue&type=template&id=0b503744"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"
script.render = render

export default script